// Preloader.jsx
import React, { useEffect, useState } from "react";

const Preloader = () => {
  const messageList = [
    "theScript, read about all your favorite news.", 
    "We are just setting up everything for you.", 
    "It won't be long now."];
    
  const [currentSentenceIndex, setCurrentSentenceIndex]               = useState(0);
  const [displayedWords, setDisplayedWords]                           = useState([]);
  const [isFading, setIsFading]                                       = useState(false);

  

   useEffect(() => {
    const currentWords = messageList[currentSentenceIndex].split(" ");
    // Start with the first word immediately
    setDisplayedWords([currentWords[0]]);
    setIsFading(false);

    let wordIndex = 0; // start from second word

    const wordInterval = setInterval(() => {
      setDisplayedWords(prev => [...prev, currentWords[wordIndex]]);
      wordIndex++;
      if (wordIndex >= currentWords.length) {
        clearInterval(wordInterval);

        // Hold sentence for 12 seconds, then fade out and switch to next
        setTimeout(() => {
          setIsFading(true);

          setTimeout(() => {
            setCurrentSentenceIndex(prev => (prev + 1) % messageList.length);
          }, 1000); // fade duration
        }, 15000);
      }
    }, 1000); // 1 second per word

    return () => clearInterval(wordInterval);
  }, [currentSentenceIndex]);

  return (
    <div className="preloader-overlay">
      <div className="loader-container">
        <div className="cube">
              <div className="cube-face front"></div>
              <div className="cube-face back"></div>
              <div className="cube-face right"></div>
              <div className="cube-face left"></div>
              <div className="cube-face top"></div>
              <div className="cube-face bottom"></div>
          </div>
          <div className="spinner"></div>
      
      </div> 
       <div className={`cop-animate ${isFading ? "fade-out" : "fade-in"}`}>
        {displayedWords.join(" ")}
      </div>  
    </div>
  );
};

export default Preloader;